/**
 * удаление класса у всех элементов
 * @param elements {NodeList}
 * @param className {String}
 */
export function removeClassFromAllElements(elements, className) {
    elements.forEach((el) => {
        el.classList.remove(className);
    });
}

/**
 * Кроссбраузерное получение позиции элемента на странице
 * @param el {HTMLElement}
 * @returns {{top: number, left: number}}
 */
export function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

/**
 * Включает/выключает скролл у html
 * @param state {Boolean} true - убрать скролл, false - overflow auto
 */
export const rootElementScrollState = (state) => {
    document.documentElement.style.overflow = state ? 'hidden' : 'auto';
};

export const removeSpacesFromString = (str) => {
    let result = str;
    if (typeof str === 'string') {
        result = str.replace(/\s/g, '');
    }
    return result;
};

/**
 * Перевод строки содержащей число в тип Number
 * строка может содержать только валидные для числа символы
 * @param str {String}
 * @return {Number|any}
 */
export const stringNumberToNumber = (str) => {
    let result = str;
    if (typeof str === 'string') {
        result = Number(removeSpacesFromString(str));
    }
    return result;
};

/**
 * Перевод строки содержащей число в тип Number
 * строка может содержать любые символы
 * @param str {String}
 * @return {Number|any}
 */
export const stringWithNumberToNumber = (str) => {
    let result = str;
    if (typeof str === 'string') {
        result = parseInt(str.replace(/[^\d]/g, ''), 10);
    }
    return result;
};

/**
 * @param {Array<String>} forms
 * @param {Number} n
 * @returns {String}
 */
export const plural = (forms, n) => {
    let idx;
    // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
    if (n % 10 === 1 && n % 100 !== 11) {
        idx = 0; // many
    } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        idx = 1; // few
    } else {
        idx = 2; // one
    }
    return forms[idx] || '';
};
